import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	coreProjectTypeValueSpork: {
		id: 'project-details.value-for-core-project-type-field-spork',
		defaultMessage: 'Jira - business project',
		description: 'Project type message for Jira business projects',
	},
	softwareProjectTypeValueSpork: {
		id: 'project-details.value-for-software-project-type-field-spork',
		defaultMessage: 'Jira - software project',
		description: 'Project type message for Jira Software projects',
	},
	serviceDeskProjectTypeValue: {
		id: 'project-details.value-for-service-desk-project-type-field',
		defaultMessage: 'Jira Service Management',
		description: 'Project type message for JSM',
	},
	productDiscoveryTypeValue: {
		id: 'project-details.value-for-product-discovery-project-type-field',
		defaultMessage: 'Jira Product Discovery',
		description: 'Project type message for Jira Product Discovery',
	},
});
